import { render, staticRenderFns } from "./ConfirmPhoneView.vue?vue&type=template&id=a9a6583a&scoped=true"
import script from "./ConfirmPhoneView.vue?vue&type=script&lang=js"
export * from "./ConfirmPhoneView.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPhoneView.vue?vue&type=style&index=0&id=a9a6583a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a6583a",
  null
  
)

export default component.exports